import { render, staticRenderFns } from "./DOTSPatientEditHistory.vue?vue&type=template&id=cc6a1774&scoped=true"
import script from "./DOTSPatientEditHistory.vue?vue&type=script&lang=js"
export * from "./DOTSPatientEditHistory.vue?vue&type=script&lang=js"
import style0 from "./DOTSPatientEditHistory.vue?vue&type=style&index=0&id=cc6a1774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6a1774",
  null
  
)

export default component.exports